/* @flow */

import InvestmentProfile from 'models/buyers/investmentProfiles/investmentProfile';

export default class UserCompanyRoleBuyer {
  canExecute: boolean;
  investmentProfiles: InvestmentProfile[];
}
